import React from 'react'

import { ActionIcon } from 'partials/PostCard/subcomponents'

import { Box } from 'widgets/Box'
import { PressableText } from 'widgets/PressableText'
import { Text } from 'widgets/Text'

import { ThemeColor } from 'utils/themes/types'

type BottomSheetNavbarProps = {
  title?: string
  boldTitle?: boolean
  shareTitle?: string
  shareColor?: ThemeColor
  onBack?: () => void
  onShare?: () => void
  onClose?: () => void
}

export const BottomSheetNavbar = ({
  title,
  boldTitle = true,
  shareTitle,
  shareColor,
  onBack,
  onShare,
  onClose,
}: BottomSheetNavbarProps) => {
  return (
    <Box
      testID='BottomSheetNavbar'
      height={50}
      width='100%'
      flexDirection='row'
      align='center'
      justifyContent='flex-start'
    >
      <Box
        flex={1}
        flexDirection='row'
        align='center'
        justifyContent='center'
        margin={{ horizontal: 'md' }}
      >
        <Text color='black' fontSize='lg' bold={boldTitle} numberOfLines={1}>
          {title ?? ''}
        </Text>
      </Box>

      <Box position='absolute' flexDirection='row' width='100%' height='100%' align='center'>
        {onBack ? (
          <ActionIcon
            label=''
            iconSize={28}
            icon='chevron-left'
            direction='row'
            color='greyDark'
            action={onBack}
          />
        ) : null}

        <Box flex={1} />

        {onShare ? (
          <PressableText bold color={shareColor ?? 'v2primary'} numberOfLines={1} onPress={onShare}>
            {shareTitle ?? 'Share'}
          </PressableText>
        ) : null}

        {onClose ? (
          <ActionIcon
            label=''
            iconSize={28}
            icon='x'
            direction='row'
            color='greyDark'
            action={onClose}
          />
        ) : null}
      </Box>
    </Box>
  )
}
